import { useEffect } from "react";
import Markdown from "react-markdown";
import api from "../api/axios";
import MermaidDiagram from "../components/MermaidDiagram";
import { useView } from "../contexts/ViewContext";
import ActivityCard from "./ActivityCard.jsx";

function Read({ learningJourneyId, view }) {
    const { setOnAdvance } = useView();

    useEffect(() => {
        const viewId = view.view_id;
        setOnAdvance(async () => {
            try {
                await api.post(`/workspace/reading/mark-complete/`, {
                    learning_journey_id: learningJourneyId,
                    view_id: viewId,
                });
            } catch (error) {
                console.error("Failed to mark reading complete:", error);
            }
        });
    }, [view.view_id, learningJourneyId, setOnAdvance]);

    // Unregister on unmount so a later, unrelated view's "Continue" click
    // can never fire this reading's completion call.
    useEffect(() => () => setOnAdvance(null), [setOnAdvance]);

    return (
        <ActivityCard view={view}>
            <div style={{ paddingRight: "10px" }}>
                <Markdown
                    components={{
                        code({ className, children, ...props }) {
                            const isMermaid = /language-mermaid/.test(className || "");
                            if (isMermaid) {
                                return <MermaidDiagram source={String(children).trim()} />;
                            }
                            return <code className={className} {...props}>{children}</code>;
                        },
                    }}
                >
                    {view.view_data.content}
                </Markdown>
            </div>
        </ActivityCard>
    );
}

export default Read;